import { FC, useEffect } from "react"
import { useModals } from "context/modals/hooks/useModals"

export const LoadPageErrorHandler: FC = () => {
  const { openModal } = useModals()

  useEffect(() => {
    openModal("pageLoadingError")
  }, [])

  return null
}
